import React from "react";
import { Button, Typography } from "@payping/web-components";
import { useAppTranslation } from "@/utils/useAppTranslation";
import EmptyBankStateIcon from "@/assets/images/empty-bank-state.svg";
import { useAppSelector } from "@/utils";

interface EmptyBankStateProps {
  onAddNew?: () => void;
  showAddButton?: boolean;
  message?: string;
  buttonText?: string;
}

const EmptyBankState: React.FC<EmptyBankStateProps> = ({ onAddNew, showAddButton = true, message, buttonText }) => {
  const { t } = useAppTranslation();
  const isUserSettlement = useAppSelector((state) => state.user.isSettlement);

  const handleAddClick = () => {
    if (onAddNew) {
      onAddNew();
    }
  };

  return (
    <div className="tw-w-full tw-py-16 tw-text-center">
      <div className="tw-mb-6 tw-flex tw-justify-center">
        <img src={EmptyBankStateIcon} alt="No bank accounts" className="tw-h-auto tw-w-24" />
      </div>
      <Typography.Text className="tw-text-gray-500 tw-mb-2 tw-block tw-text-base">
        {message || t("profile.noSheba")}
      </Typography.Text>
      {showAddButton && (
        <Button type="primary" onClick={isUserSettlement ? undefined : handleAddClick} disabled={isUserSettlement}>
          {buttonText || t("profile.bank.addNewIBAN")}
        </Button>
      )}
    </div>
  );
};

export default EmptyBankState;
